export const TwitterIcon = ({
  width = 24,
  height = 24,
  title = "Twitter",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}>
      <title>{title}</title>
      <path
        fill="#F5F6F7"
        d="m13.676 10.659 6.553-7.46h-1.552l-5.693 6.476-4.543-6.476H3.2l6.871 9.793L3.2 20.814h1.552l6.007-6.84 4.8 6.84h5.24M5.313 4.346h2.385l10.978 15.378H16.29"></path>
    </svg>
  );
};
